import { AnimationType, Direction } from './types';

export class AnimationManager {
	private _currentAnimation!: AnimationType;
	private _lastAnimation!: AnimationType;
	private _currentFrame: number = 0;
	private _frameCounter: number = 0;
	frameSpeed: number = 5;
	attackFrameSpeed: number = 2;
	private _direction: Direction = 'east';
	private _lastDirection: Direction = 'east';

	private animations!: Record<AnimationType, Record<Direction, p5.Image[]>>;

	constructor() {
		this._currentAnimation = 'idle';
		this._lastAnimation = 'idle';
	}

	// Getters and setters
	get currentAnimation(): AnimationType {
		return this._currentAnimation;
	}

	set currentAnimation(value: AnimationType) {
		this._currentAnimation = value;
	}

	get lastAnimation(): AnimationType {
		return this._lastAnimation;
	}

	set lastAnimation(value: AnimationType) {
		this._lastAnimation = value;
	}

	get currentFrame(): number {
		return this._currentFrame;
	}

	set currentFrame(value: number) {
		this._currentFrame = value;
	}

	get frameCounter(): number {
		return this._frameCounter;
	}

	set frameCounter(value: number) {
		this._frameCounter = value;
	}

	get direction(): Direction {
		return this._direction;
	}

	set direction(value: Direction) {
		this._direction = value;
	}

	get lastDirection(): Direction {
		return this._lastDirection;
	}

	set lastDirection(value: Direction) {
		this._lastDirection = value;
	}

	setAnimations(animations: Record<AnimationType, Record<Direction, p5.Image[]>>): void {
		this.animations = animations;
	}

	getCurrentSprite(): p5.Image | null {
		const frames = this.animations[this._currentAnimation]?.[this._direction];
		if (!frames || frames.length === 0) {
			return null;
		}
		return frames[this._currentFrame] || null;
	}

	getFrames(): p5.Image[] {
		return this.animations[this._currentAnimation]?.[this._direction] || [];
	}

	turn(newDirection: Direction): void {
		if (this._direction !== newDirection) {
			this._lastDirection = this._direction;
			this._direction = newDirection;
			// Direction değiştiğinde frame'i geçerli aralığa modüle et
			const frames = this.getFrames();
			if (frames && frames.length > 0) {
				this._currentFrame = this._currentFrame % frames.length;
			}
		}
	}

	reset(): void {
		this._currentAnimation = 'idle';
		this._lastAnimation = 'idle';
		this._currentFrame = 0;
		this._frameCounter = 0;
		this._direction = 'east';
		this._lastDirection = 'east';
	}

	updateFrame(): void {
		const frames = this.getFrames();
		if (frames.length === 0) {
			return;
		}

		// Animasyon değiştiğinde frame'i modüle et ve frame counter'ı resetle
		if (this._currentAnimation !== this._lastAnimation) {
			this._lastAnimation = this._currentAnimation;
			this._currentFrame = this._currentFrame % frames.length;
			this._frameCounter = 0;
		}

		// Frame'i her zaman geçerli aralıkta tut
		this._currentFrame = this._currentFrame % frames.length;
	}
}
